import { useRouter } from "next/router";

const VISITED_FACILITY_KEY = "visited_facility";

const FACILITY_PATHS = [
  "/parlor",
  "/parlors/region",
  "/parlor-recommend-list/region",
  "/crematorium",
  "/crematorium-recommendation",
  "/crematoriums/region",
  "/facilities",
  "/match/parlor-requests",
  "/match/facility-requests",
  "/match/crematorium-request",
  "/match/parlor-match-request",
  "/match/facility-match-request",
  "/match/facility-recommendation",
  "/promotion/jangji",
  "/directors-parlor",
];

const isFacilityPathname = (pathname: string): boolean => {
  return FACILITY_PATHS.some((p) => pathname === p || pathname.startsWith(p + "/"));
};

export const useTrackFacilityVisit = () => {
  const router = useRouter();

  const trackVisit = () => {
    if (typeof window === "undefined") return;
    if (!isFacilityPathname(router.pathname)) return;

    sessionStorage.setItem(VISITED_FACILITY_KEY, "true");
  };

  return { trackVisit };
};

export const hasVisitedFacility = (): boolean => {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem(VISITED_FACILITY_KEY) === "true";
};
